import React, { useEffect, useState, type ReactNode } from 'react';
import { toProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { useCoordinationClient } from './services/coordination-client/index.tsx';

type EPCheckProps = {
	onComplete: () => void;
	children: ReactNode;
};
export const EPCheck = ({ onComplete, children }: EPCheckProps) => {
	const { data: project } = useProject();
	const projectType = toProjectType(project?.type);

	const [hasMessageStarted, setHasMessageStarted] = useState(false);
	const [hasCheckedEpMessage, setHasCheckedEpMessage] = useState(false);
	const { start: checkEPMessage } = useCoordinationClient(projectType);

	useEffect(() => {
		// reset checks when we switch projects
		setHasCheckedEpMessage(false);
		setHasMessageStarted(false);
	}, [projectType]);

	useEffect(() => {
		if (hasCheckedEpMessage || projectType === undefined) return;

		(async () => {
			setHasCheckedEpMessage(true);
			const hasStarted = await checkEPMessage();

			setHasMessageStarted(hasStarted);
			hasStarted && onComplete();
		})();
	}, [checkEPMessage, hasCheckedEpMessage, onComplete, projectType]);

	return <>{hasMessageStarted && children}</>;
};
